import moment from "moment";
import { useEffect, useState } from "react";
import { LuArrowRight, LuArrowUpRight } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api/api";
import {
  GeneralPaymentDetails,
  InitiateMedicalFeePayment,
  InitiateOtherFeePayment,
  InitiateSchoolFeePayment,
} from "../../api/student";
import Footer from "../../components/Footer";
import SchoolFeeComponent from "../../components/SchoolFeeComponent";
import useActiveSession from "../../hooks/useActiveSession";
import useDetails from "../../hooks/useDetails";
import usePayments from "../../hooks/usePayments";
import { OTHER_FEE_OPTIONS, paymentTypes, sessionList } from "../../utils";
import { getCurrentUser } from "../../utils/authService";

const OtherFees = () => {
  const user = getCurrentUser();
  const [schoolFee, setSchoolFee] = useState();
  const [loading, setLoading] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentLevel, setPaymentLevel] = useState("");
  const [paymentSession, setPaymentSession] = useState("");
  // const [paidSchoolFee, setPaidSchoolFee] = useState(false);
  const [showAmount, setShowAmount] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [levels, setLevels] = useState([]);
  const [btnText, setBtnText] = useState("Proceed to payment");
  const navigate = useNavigate();
  const { session } = useActiveSession();
  const { data } = useDetails();
  const { payment, schoolFeesPayment } = usePayments();

  let is_graduated = data?.is_graduated;

  const getPaymentDetails = async () => {
    if (!paymentType || !paymentLevel || !paymentSession) return;
    setLoading(true);
    try {
      let results;
      if (OTHER_FEE_OPTIONS.some((data) => data === paymentType)) {
        const { data } = await api.post("/payments/other-fee/generate/", {
          student_id: user.role_id,
          payment_type: paymentType,
          level: paymentLevel,
          session_id: Number(paymentSession),
        });
        results = data;
      } else {
        const { data } = await api.post("/payments/generate/payment/", {
          student_id: user.role_id,
          payment_type: paymentType,
          level: paymentLevel,
          session_id: Number(paymentSession),
        });
        results = data;
      }
      console.log("ccccc", results);
      setLoading(false);
      setSchoolFee(results);
      setShowAmount(true);
    } catch (error) {
      console.log(error, "errrorrr");
      setLoading(false);
      toast.error(
        error.response.data.detail || "Error fetching payment details",
      );
      setShowAmount(false);
      setSchoolFee(null);
      setPaymentType("");
      setPaymentLevel("");
      setPaymentSession("");
    }
  };

  const returnSession = (id) => {
    const session = sessions.find((session) => session.id === Number(id));
    return session?.name;
  };

  const paySchoolFee = async () => {
    const confirm = window.confirm(
      `Are you sure you want to proceed with this payment?
      Payment Type: ${paymentType}\n
      Payment Level: ${paymentLevel}\n
      Payment Session: ${returnSession(paymentSession)}.\n
      Please check the details above. This action is not reversible.`,
    );
    if (!confirm) return;
    try {
      setBtnText("Initializing...");
      setLoading(true);
      const data = await InitiateSchoolFeePayment({
        student_id: user.role_id,
        payment_type: paymentType,
        custom_amount: schoolFee?.amount,
        session_id: Number(paymentSession),
      });
      console.log("payment oh", data);
      const { payment_link } = data;
      toast.success("Initiating payment");
      window.location.replace(payment_link);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(error.response.data.detail || "Initiating payment failed!");
      setBtnText("Initiating payment failed!");
    }
  };

  const payOtherFee = async () => {
    const confirm = window.confirm(
      `Are you sure you want to proceed with this payment?
      Payment Type: ${paymentType}\n
      Payment Level: ${paymentLevel}\n
      Payment Session: ${returnSession(paymentSession)}.\n
      Please check the details above. This action is not reversible.`,
    );
    if (!confirm) return;
    try {
      setBtnText("Initializing...");
      setLoading(true);
      const data = await InitiateOtherFeePayment({
        student: user.role_id,
        payment_option: paymentType,
        custom_amount: schoolFee?.amount,
        session: Number(paymentSession),
      });
      console.log("payment oh", data);
      const { payment_link } = data;
      toast.success("Initiating payment");
      window.location.replace(payment_link);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error("Initiating payment failed!");
      setBtnText("Initiating payment failed!");
    }
  };

  const getSession = async () => {
    try {
      const { data } = await api.get("/portal/academic-sessions/");
      setSessions(data?.results);
    } catch (error) {
      console.log(error);
    }
  };

  const getLevels = async () => {
    try {
      const { data } = await api.get(
        `/payments/generate/level-options/?student_id=${user.role_id}`,
      );
      console.log("levels", data);
      setLevels(data?.valid_levels);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSession();
    getLevels();
  }, []);

  useEffect(() => {
    if (!paymentType) return; // nothing selected yet

    getPaymentDetails();
  }, [paymentType, paymentLevel, paymentSession]);

  useEffect(() => {
    if (schoolFeesPayment && session) {
      // Check if any payment matches the active session
      const hasPaid = schoolFeesPayment.some(
        (payment) => payment.payment_session === session.name,
      );
      // setPaidSchoolFee(hasPaid);
    }
  }, [schoolFeesPayment, session]);

  // const is_graduated = true;
  const paymentCategories = is_graduated
    ? paymentTypes?.filter((p) => p.key === "FINAL_CLEARANCE")
    : paymentTypes?.filter((p) => p.key !== "FINAL_CLEARANCE");

  const paidSchoolFee = data?.payment_complete;

  return (
    <>
      <div>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <h1 className="text-2xl font-bold text-brand-darkGray">
              Other Fees
            </h1>
            <p className="text-sm text-gray-400">View all payments</p>
          </div>

          <div className="flex gap-3">
            <button
              className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
              onClick={() => navigate("/payments")}
            >
              <p className="text-sm font-medium text-white">Invoice</p>
              <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
                <LuArrowUpRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
              </div>
            </button>
          </div>
        </div>

        <div className="mt-6 card-body rounded-xl bg-white space-y-10">
          <h5 className="text-lg font-semibold text-brand-darkGray">
            &#x2022; Student information
          </h5>

          <div className="w-full space-y-5">
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Matriculation Number
                </label>
                <input
                  type="text"
                  defaultValue={data?.matric_number}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Academic Session
                </label>
                <input
                  type="text"
                  defaultValue={data?.session?.name}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Faculty
                </label>
                <input
                  type="text"
                  defaultValue={data?.faculty}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Department
                </label>
                <input
                  type="text"
                  defaultValue={data?.department}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full lg:w-[49.3%]">
                <label className="text-sm font-medium text-gray-600">
                  Fee Payment
                </label>
                <input
                  type="text"
                  value={
                    paidSchoolFee === null
                      ? "Not Paid"
                      : paidSchoolFee?.toLowerCase() === "full"
                        ? "Paid (Full Payment)"
                        : paidSchoolFee?.toLowerCase() === "part"
                          ? "Paid (Part Payment)"
                          : "Not Paid"
                  }
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div class="p-6 bg-white rounded-xl shadow-md mt-6 card-body  space-y-10 overflow-hidden">
          <div className="">
            <h2 class="text-lg font-semibold mb-4"> &#x2022; Payment</h2>
          </div>

          <div class="overflow-x-auto  flex items-center justify-between gap-3">
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Select the payment you want to make
              </label>
              <div className="w-full lg:w-[56%]">
                {/* <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                >
                  <option value="">{`--Select--`}</option>
                  {paymentTypes.map((option, index) => (
                    <option key={index} value={option.key}>
                      {option.name}
                    </option>
                  ))}
                </select> */}

                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentType}
                  onChange={(e) => {
                    const selected = e.target.value;
                    // Default flow
                    setPaymentType(selected);
                  }}
                >
                  <option value="">{`--Select--`}</option>
                  {paymentCategories?.map((option, index) => (
                    <option key={index} value={option.key}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <label className="text-sm font-medium text-gray-600 mt-4">
                Select the level
              </label>
              <div className="w-full lg:w-[56%]">
                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentLevel}
                  onChange={(e) => {
                    setPaymentLevel(e.target.value);
                  }}
                >
                  <option value="">{`--Select--`}</option>
                  {levels.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <label className="text-sm font-medium text-gray-600 mt-4">
                Select the session
              </label>
              <div className="w-full lg:w-[56%] ">
                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentSession}
                  onChange={(e) => {
                    setPaymentSession(e.target.value);
                  }}
                >
                  <option value="">{`--Select--`}</option>
                  {sessions.map((session, index) => (
                    <option key={index} value={session.id}>
                      {session.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {showAmount && (
            <div className="flex flex-col">
              <div className="bg-blue-50 px-4 py-8 rounded-md text-4xl">
                {loading
                  ? "Please wait..."
                  : Number(schoolFee?.amount).toLocaleString("en-NG", {
                      style: "currency",
                      currency: "NGN",
                    })}
              </div>
              {/* <div className="flex pt-4">
                <button
                  className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
                  onClick={() => paySchoolFee()}
                >
                  <p className="text-sm font-medium text-white">{btnText}</p>
                  <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
                    <LuArrowRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
                  </div>
                </button>
              </div> */}

              <div className="flex pt-4">
                <button
                  className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out disabled:bg-[#5D71C0]/50 disabled:cursor-not-allowed" disabled={loading}
                  onClick={() => {
                    if (
                      OTHER_FEE_OPTIONS.some((data) => data === paymentType)
                    ) {
                      payOtherFee();
                    } else {
                      paySchoolFee();
                    }
                  }}
                >
                  <p className="text-sm font-medium text-white">
                    {OTHER_FEE_OPTIONS.some((data) => data === paymentType)
                      ? `Proceed to ${OTHER_FEE_OPTIONS.find((data) => data === paymentType)} payment`
                      : btnText}
                  </p>
                  <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
                    <LuArrowRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
                  </div>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default OtherFees;
